import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faAngellist } from '@fortawesome/free-brands-svg-icons/faAngellist';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/LaurentShen',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://facebook.com/',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.instagram.com/laurentshen8613/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.bilibili.com/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://angel.co/michael-d-angelo',
    label: 'Angel List',
    icon: faAngellist,
  },
  {
    link: 'https://www.baidu.com/',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'mailto:michael.l.dangelo@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
